"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatProcessorImpl = void 0;
const clock_1 = require("@almservices-cl/clock");
const sleep_1 = require("./sleep");
class ChatProcessorImpl {
    constructor(chatQueue, pmpChatApi, pbpChatApi, logger, messageMaker, chatCache, identityService) {
        this.process = async () => {
            this.logger.log("Chat processor running...");
            const isNext = await this.chatQueue.fetch(async ({ message, memberId, timeZone: timeZoneStr, application, }) => {
                this.logger.log("Processing message");
                const timeZone = clock_1.UTCTimeZone.fromString(timeZoneStr);
                const id = await this.getApi(application).send(message, memberId);
                await this.chatCache.push(this.messageFactory.make(await this.identityService.getId(), await this.identityService.getDisplayName(), message, timeZone, id), memberId);
            });
            if (!isNext) {
                this.logger.log("Chat Processor done");
                return;
            }
            await (0, sleep_1.sleep)(1000); // 1 sec interval, due to backward compatibility in older applications as messages are identified and ordered by time
            await this.process();
        };
        this.getApi = (application) => application == "PBP" ? this.pbpApi : this.pmpApi;
        this.pmpApi = pmpChatApi;
        this.pbpApi = pbpChatApi;
        this.chatQueue = chatQueue;
        this.logger = logger;
        this.messageFactory = messageMaker;
        this.chatCache = chatCache;
        this.identityService = identityService;
    }
    async goOffline() {
        this.logger.log("Chat goes offline");
    }
    async goOnline() {
        this.logger.log("Chat goes online");
        await this.process();
    }
}
exports.ChatProcessorImpl = ChatProcessorImpl;
//# sourceMappingURL=ChatProcessor.js.map